<div class="embedded-grid" [nbSpinner]="this.isLoading">
  <ejs-grid #lotGrid [dataSource]="this.lots" [columns]="this.columns" [allowTextWrap]="true" [allowSorting]="true">
  </ejs-grid>
</div>

<ng-template #actionTemplate let-data>
  <button mat-icon-button type="button" aria-label="Lot actions" (click)="actionsClicked(data)">
    <fa-icon [icon]="faEllipsisVertical"></fa-icon>
  </button>
</ng-template>
